/**
 * Macro Simulator v0.1 - Technical Particle Physics (Archived)
 * Original 6-entity implementation
 */
import { useState, useEffect, useRef } from 'react'
import { initializeSimulation } from '../utils/simulator/simulationEngine'
import SimulatorCanvas from '../components/simulator/SimulatorCanvas'
import MarketDataPanel from '../components/simulator/MarketDataPanel'
import ActivityTimeline from '../components/simulator/ActivityTimeline'
import SimulationControls from '../components/simulator/SimulationControls'

export default function MacroSimulatorV1() {
  const [isPaused, setIsPaused] = useState(false)
  const [activities, setActivities] = useState([])
  const [marketData, setMarketData] = useState({
    people: { particles: 150, premiums: 0, claims: 0 },
    businesses: { particles: 150, premiums: 0, claims: 0 },
    agencies: { particles: 150, commissions: 0 },
    carriers: { particles: 75, premiums: 0, claims: 0, profit: 70 },
    wholesalers: { particles: 60, commissions: 0 },
    reinsurance: { particles: 25, cedingPremiums: 0, recoveries: 0 }
  })

  const addActivity = (activity) => {
    setActivities(prev => [activity, ...prev].slice(0, 50))
  }

  const clearActivities = () => {
    setActivities([])
  }

  const togglePause = () => {
    setIsPaused(prev => !prev)
  }

  return (
    <div className="min-h-screen bg-black text-white p-8">
      <div className="max-w-[1600px] mx-auto">
        {/* Version Notice */}
        <div className="bg-orange-900/20 border border-orange-900/50 rounded-lg p-4 mb-6">
          <div className="flex items-start gap-3">
            <span className="text-2xl">⚠️</span>
            <div>
              <div className="font-semibold text-orange-400 mb-1">Archived Version - v0.1</div>
              <div className="text-sm text-[#ccc]">
                This is the original technical implementation with 6-entity particle physics. 
                Preserved for reference. See v0.2 for the consumer-focused version.
              </div>
            </div>
          </div>
        </div>

        <header className="text-center mb-12">
          <h1 className="text-4xl font-light tracking-[2px] mb-2.5 bg-gradient-to-r from-[#667eea] to-[#764ba2] bg-clip-text text-transparent">
            Insurance Macro Economics Simulator
          </h1>
          <p className="text-[#888] text-base tracking-[1px]">
            v0.1 - Particle-based economic visualization
          </p>
        </header>

        <SimulatorCanvas 
          isPaused={isPaused}
          onActivityAdd={addActivity}
          onMarketDataUpdate={setMarketData}
        />

        <MarketDataPanel data={marketData} isPaused={isPaused} />
        <ActivityTimeline activities={activities} onClear={clearActivities} isPaused={isPaused} />
        <SimulationControls isPaused={isPaused} onTogglePause={togglePause} />
      </div>
    </div>
  )
}

